// Copyright (c) 2025. CYBERKOALA LLC.
//
// SPDX-License-Identifier: Proprietary License.
//
// Redistribution and use in source and binary forms, with or without
// modification, are restricted.

export const DEVELOPMENT = false;
  // process.env.NODE_ENV === 'development' || false;
// USED CLIENT-SIDE HARDCODED VALUES, WARN: ALL file is EXPOSED TO WEB
export const HOST_URL = 'https://web.calls.cyberkoala.ru';
export let API_BASE = 'https://web.calls.cyberkoala.ru'; // auth will not work if running localhost
/**
 * @deprecated
 */
export const LAPUSHOK_URL = 'https://pns.cyberkoala.ru';
export const API_IP_DETECTOR = 'https://ns1.dns.tuchacloud.ru:4001'; // stun.tuchacloud
// export let TPRESENCE_ADDRESS = 'wss://stun.tuchacloud.ru:3001';
export let TPRESENCE_ADDRESS =
  'wss://presence.calls.cyberkoala.ru?token=mighty-solid-rock-press'; // WARN: this is exposes to clients
export const DEEPLINK_PREFIX = 'cyberkoalacalls://';
if (DEVELOPMENT) {
  API_BASE = 'http://localhost:4000';
  // LAPUSHOK_URL = 'http://localhost:24014';
  // TPRESENCE_ADDRESS = 'ws://localhost:3001?token=mighty-solid-rock-press';
}
export const NEXT_PUBLIC_LIVEKIT_WS_URL = 'wss://ns2.dns.tuchacloud.ru';
export const CDN_VERSION_URL= 'https://ccalls.site/cdn/dist/version.json';
export const DEFAULT_LOGIN_REDIRECT = '/channels/@me';
export const GAME_POLLING_INTERVAL = 20 * 1_000; // 20 seconds used for profiles // TODO: instead connect to SSE events with GameActivity, currentGame (from user)

/**
 * If domains are 3rd level may cause memory overflow
 */
export const WHITELISTED_DOMAINS = [
  'talksy.ru',
  'cyberkoala.ru',
  'cyberkoalastudios.com',
  'tuchacloud.ru',
  'lrn4.ru',
  'vk.com',
  'telegram.com',
  't.me',
  'ok.ru',
  'google.com',
  'google.ru',
  'github.com',
  'steamcommunity.com',
  'steam.com',
  'steampowered.com',
  'freebsd.org',
  'gosuslugi.ru',
  'mos.ru',
  'mail.ru',
  'microsoft.com',
  'ccalls.site',
  'youtube.com',
  'youtu.be',
  'rutube.ru',
  'dns-shop.ru',
  'ozon.ru',
  'yandex.ru',
  'dzen.ru',
  'yandex.ru',
  'activemattergame.ru',
  'basealt.ru',
  'altlinux.org',
  'playground.ru',
  'vkplay.ru',
  'twitch.tv',
  'dtf.ru',
  'igromania.ru',
  'vkvideo.ru'
];
/**
 * @deprecated
 */
export const GUARDIAN_IPS = [];
export const S3_ENDPOINT_BUCKET = 'https://s3.cyberkoala.ru/talksy';
export const BASE_BUCKET_URL = 'https://s3-2.cyberkoala.ru/talksy-d/';
export const CDN_APP_URL = 'https://ccalls.site/cdn/talksy-d/';
export const CYBERKOALA_ID_SDK_CONFIG = {
  serverUrl: 'https://id.cyberkoala.ru',
  clientId: '2c0714878b68982293eb',
  organizationName: 'cyberkoala-llc',
  appName: 'talksy',
  redirectPath: '/callback',
};
export const KASPERSKY_API_KEY = 'hAVOWndOSbKPGily+TxBNg==';
export const CSRF_COOKIE_NAME = 'csrf_token';
export const CSRF_HEADER_NAME = 'x-csrf-token';
export const ADMIN_TOKEN = 'E6658FBD6CCDA2AE60B0B3453962E078'; // WARNING: this is exposing to clients. Better to fetch from API
export const INVITE_SHORT_DOMAIN = 'ccalls.site';
export const VK_APP_ID = 54639180;
export const AI_ENDPOINT = 'wss://ai.cyberkoala.ru';
export const REMOTE_PLAY_ENDPOINT = 'wss://play.cyberkoala.ru';
